unit f_comunicaassenza;

{$mode objfpc}

interface

uses
  Classes, SysUtils, un_widget, w_table, web, js, un_tquery, un_formatsettings,
  un_user, f_selezione, un_servermodule, un_generator, DateUtils, DB, f_modificaassenza;

type

  { TFrmComunicaAssenza }

  TFrmComunicaAssenza = class(TWidget)
    procedure AfterRender;
    procedure AfterDomAppend; async; override;
    procedure salva_click(Event: TJSEvent); async;

  published
    procedure ShowComunicaAssenze; async;
    function DateOk:Boolean;
    procedure dtdata1_change;
    procedure dtdata2_change;
    procedure tab1_rowclick; async;
    procedure idutente_click; async;
    whereDate :String;
    titolo: TJSHTMLElement;
    dtdata1 : TJSHTMLInputElement;
    dtdata2 : TJSHTMLInputElement;
    dsnote : TJSHTMLInputElement;
    idutente : TJSHTMLInputElement;
    dsutente : TJSHTMLInputElement;
    salva:TJSHTMLButtonElement;
    pnlDati:TJSHTMLElement;
    QryComunicaAssenza: TQuery;
    QryAnagrafica: TQuery;
    QryUtenti: TQuery;
    QryResponsabile: TQuery;
    tab1:TWTable;
  end;

implementation

{$R *.html}

{ TFrmComunicaAssenza }


procedure TFrmComunicaAssenza.AfterRender;
var
  dataminfiltro : String;
  datamaxfiltro : String;
begin
  // Recupero le date memorizzate nella sessione corrente
  if (window.sessionStorage[ClassName+'_data1'] <> '') and
     (window.sessionStorage[ClassName+'_data2'] <> '') then
  begin
    dtdata1.value := window.sessionStorage[ClassName+'_data1'];
    dtdata2.value := window.sessionStorage[ClassName+'_data2'];
  end
  else
  begin
    // Primo ingresso dopo l'apertura dell'applicazione
    dataminfiltro := FormatDateTime('yyyy-mm-dd', Date);
    datamaxfiltro := FormatDateTime('yyyy-mm-dd', IncDay(Date, 30));

    dtdata1.value := dataminfiltro;
    dtdata2.value := datamaxfiltro;

    window.sessionStorage[ClassName+'_data1'] := dtdata1.value;
    window.sessionStorage[ClassName+'_data2'] := dtdata2.value;
  end;

  idutente.value := user.QryUtenti.FieldByName('idanagrafica').AsString;
  dsutente.value  := user.QryUtenti.FieldByName('dsutente').AsString;

  ShowComunicaAssenze;

  tab1.RenderDataSet(nil);
end;

procedure TFrmComunicaAssenza.AfterDomAppend;
begin
//
end;

procedure TFrmComunicaAssenza.salva_click(Event: TJSEvent);
var
  nID: Integer;
begin
  // 1. Validazione date vuote
  if (dtdata1.value = '') or (dtdata2.value = '') then
  begin
    ShowMessage('Inserire entrambe le date.');
    Exit;
  end;

  // --- NUOVO CONTROLLO DI CONFERMA ---
  // Chiede conferma all'utente usando la finestra nativa del browser
  if not window.confirm('Sei sicuro di voler salvare la comunicazione di assenza?') then
  begin
    // Se l'utente clicca su "Annulla", usciamo dalla procedura senza fare nulla
    Exit;
  end;
  // ------------------------------------

  // Disabilito il tasto per evitare doppi invii durante l'attesa (await)
  TJSHTMLButtonElement(Event.Target).disabled := True;

  try
    try
      // 2. Preparazione Query (solo schema)
      QryComunicaAssenza.Close;
      QryComunicaAssenza.SQL.Text := 'SELECT IDCO_COMUNICAASSENZA, IDSOCIETA, DTASSENTEDA, DTASSENTEA, IDANAGRAFICA, DSVOLONTARIO, DSNOTE FROM vo_comunicaassenza WHERE 1=0';
      await(QryComunicaAssenza.Open);

      // 3. Recupero ID
      nID := await(GetNextId('CO_COMUNICAASSENZA'));

      // 4. Inserimento nel Buffer locale
      QryComunicaAssenza.Append;
      QryComunicaAssenza.FieldByName('IDCO_COMUNICAASSENZA').AsInteger := nID;
      QryComunicaAssenza.FieldByName('IDSOCIETA').AsString := 'DON001';

      // Conversione Date
      QryComunicaAssenza.FieldByName('DTASSENTEDA').AsDateTime :=
        EncodeDate(StrToInt(Copy(dtdata1.value, 1, 4)), StrToInt(Copy(dtdata1.value, 6, 2)), StrToInt(Copy(dtdata1.value, 9, 2)));
      QryComunicaAssenza.FieldByName('DTASSENTEA').AsDateTime :=
        EncodeDate(StrToInt(Copy(dtdata2.value, 1, 4)), StrToInt(Copy(dtdata2.value, 6, 2)), StrToInt(Copy(dtdata2.value, 9, 2)));
//      QryComunicaAssenza.FieldByName('IDANAGRAFICA').AsInteger := user.QryUtenti.FieldByName('idanagrafica').AsInteger;
//    QryComunicaAssenza.FieldByName('DSVOLONTARIO').AsString  := user.QryUtenti.FieldByName('dsutente').AsString;
      QryComunicaAssenza.FieldByName('IDANAGRAFICA').AsString := idutente.value;
      QryComunicaAssenza.FieldByName('DSVOLONTARIO').AsString := dsutente.value;
      QryComunicaAssenza.FieldByName('DSNOTE').AsString        := dsnote.value;

      QryComunicaAssenza.Post;

      // 5. Invio al Server
      await(QryComunicaAssenza.ApplyUpdates);

      ShowMessage('Assenza registrata con successo (ID: ' + IntToStr(nID) + ')');

      QryComunicaAssenza.Close;

    except
      on E: Exception do
        ShowMessage('Errore durante il salvataggio: ' + E.Message);
    end;
  finally
    // Riabilito il tasto in ogni caso (sia successo che errore)
    TJSHTMLButtonElement(Event.Target).disabled := False;
  end;

  // Mantengo le date anche dopo il salvataggio
  window.localStorage[ClassName+'_data1'] := dtdata1.value;
  window.localStorage[ClassName+'_data2'] := dtdata2.value;

  ShowComunicaAssenze;

  // --- PULIZIA POST-SALVATAGGIO ---
  // Le date NON vengono cancellate.
  dsnote.value := '';
end;

procedure TFrmComunicaAssenza.ShowComunicaAssenze;
var
  IdUtenteLoggato: string;
begin
  window.localStorage[ClassName+'_data1'] := dtdata1.value;
  window.localStorage[ClassName+'_data2'] := dtdata2.value;

  if not DateOk then
    exit;

    IdUtenteLoggato := user.QryUtenti.FieldByName('idanagrafica').AsString;
    console.log('utente' + user.QryUtenti.FieldByName('idanagrafica').AsString);

    // 1. Verifico se l'utente appartiene al gruppo RESP
    QryResponsabile.Close;
    QryResponsabile.SQL.Text := 'select * from utentigruppi '
      + ' where idsocieta = ''DON001'' '
      + ' and idanagrafica = ' + QuotedStr(IdUtenteLoggato)
      + ' and idgruppo = ''RESP'' ';
    AWait(QryResponsabile.Open);

    // MODIFICA: se non è responsabile, rende non modificabili i campi utente
    if QryResponsabile.IsEmpty then
    begin
      idutente.ReadOnly := True;
      dsutente.ReadOnly := True;
    end
    else
    begin
      idutente.ReadOnly := False;
      dsutente.ReadOnly := False;
    end;

    // 2. Costruisco la query principale
    QryComunicaAssenza.Close;
    QryComunicaAssenza.SQL.Text := 'select DSVOLONTARIO AS VOLONTARIO, DTASSENTEDA AS DAL, '
      + ' DTASSENTEA AS AL, DSNOTE AS NOTE, IDCO_COMUNICAASSENZA from vo_comunicaassenza '
      + ' where idsocieta = ''DON001'' '
      + ' and ' + whereDate;

    // 3. LOGICA DI FILTRO:
    // Se NON è responsabile, deve vedere solo se stesso.
    // Uso l'ID dell'utente loggato per filtrare sulla tabella assenze.
    if QryResponsabile.IsEmpty then
    begin
      // NOTA: Assicurati che il campo nella tabella vo_comunicaassenza
      // che contiene l'ID dell'utente sia effettivamente 'IDUTENTE' o 'IDANAGRAFICA'
      QryComunicaAssenza.SQL.Add(' and idanagrafica = ' + QuotedStr(IdUtenteLoggato));
    end;

    // 4. Ordinamento finale
    QryComunicaAssenza.SQL.Add(' order by dtassenteda desc');

    AWait(QryComunicaAssenza.Open);

    QryComunicaAssenza.FieldByName('IDCO_COMUNICAASSENZA').Visible:= false;

    tab1.RenderDataSet(QryComunicaAssenza);

end;

function TFrmComunicaAssenza.DateOk: Boolean;
var
  dt1, dt2: TDateTime;
  dt1str, dt2str :String;
begin
  Result :=  False;
  if dtdata1.value = '' then
  begin
    ShowMessage('Compila la data assente da');
    dtdata1.focus;
    exit;
  end;

  if dtdata2.value = '' then
  begin
    ShowMessage('Compila la assente a');
    dtdata2.focus;
    exit;
  end;

  dt1 := ScanDateTime('yyyy-MM-dd',dtdata1.value);
  dt2 := ScanDateTime('yyyy-MM-dd',dtdata2.value) ;
//  dt2 := IncDay(dt2);
  //dt1str := FormatDateTime('dd.MM.yyyy',dt1);
  //dt2str := FormatDateTime('dd.MM.yyyy',dt2);
  dt1str := FormatDateTime('yyyy-mm-dd', dt1);
  dt2str := FormatDateTime('yyyy-mm-dd', dt2);


  whereDate := (' dtassenteda <= ''' + dt2str + ''''
    + ' and dtassentea >= ''' + dt1str + '''');

  Result := True;

end;

procedure TFrmComunicaAssenza.dtdata1_change;
begin
  ShowComunicaAssenze;
end;

procedure TFrmComunicaAssenza.dtdata2_change;
begin
  ShowComunicaAssenze;
end;

procedure TFrmComunicaAssenza.tab1_rowclick;
var
  instance: TFrmModificaAssenza;
  data1, data2: String;
begin
  // Salvo le date presenti nella form principale
  data1 := dtdata1.value;
  data2 := dtdata2.value;

  // Memorizzo le date anche nel localStorage per evitare
  // che vengano sovrascritte durante il ritorno dalla form di modifica
  window.localStorage[ClassName+'_data1'] := data1;
  window.localStorage[ClassName+'_data2'] := data2;

  instance := TFrmModificaAssenza.Create();
  instance.idassenza := QryComunicaAssenza.FieldByName('idco_comunicaassenza').AsInteger;

  Await(instance.show);

  // Ripristino le date nella form principale
  dtdata1.value := data1;
  dtdata2.value := data2;

  // Mantengo le date anche nel localStorage
  window.localStorage[ClassName+'_data1'] := data1;
  window.localStorage[ClassName+'_data2'] := data2;

  // Aggiorno la tabella mantenendo le date salvate
  Await(ShowComunicaAssenze);
end;

procedure TFrmComunicaAssenza.idutente_click;
begin
  // MODIFICA: i non responsabili non possono scegliere un altro utente
  if QryResponsabile.IsEmpty then
    Exit;

  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;
      QrySeleziona.Close;
      QrySeleziona.SQL.Text:= ' select idanagrafica, dsragionesociale '
       + ' from an_anagrafiche ';
      AWait(QrySeleziona.Open);
    end;

    if AWait(Show) = mrOK then
    begin
      idutente.value := QrySeleziona.FieldByName('idanagrafica').AsString;
      dsutente.value := QrySeleziona.FieldByName('dsragionesociale').AsString;
    end;
  end;

end;


initialization
  RegisterWeb(TFrmComunicaAssenza);

end.

